export interface ICustomerData {
    companyName: string;
    address: string;
    address2: string;
    zip: string;
    country: string;
    city: string;
    industry: string;
    taxDomicile: string;
    uid: string;
}
